import QuestionHeader from "../question-header";
import SelectableOption from "../selectable-option";

export const SingleSelectQuestion = ({ question, value, onChange, error }) => {
  return (
    <div className="flex flex-col min-h-0 space-y-6">
      <QuestionHeader label={question.label} required={question.required} description={question.description} />

      <div className="flex-1 min-h-0 overflow-y-auto space-y-3 pr-2">
        {question.options.map((option) => (
          <SelectableOption
            key={option?.id}
            label={option?.text}
            selected={value === option?.id}
            onSelect={() => onChange(option?.id)}
            type="radio"
            error={error}
          />
        ))}
      </div>
    </div>
  );
};
